module.exports = __webpack_public_path__ + "img/1440.8c2cae52.jpg";